import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
	LARGE: 'large',
};

const LockIconStyle = Styled.span`
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	align-items: center;
	cursor: pointer;
`;

export const LockIcon = ({size, color, onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '10';
			case SIZE.STANDARD:
				return '16';
			case SIZE.LARGE:
				return '40';
			default:
				return '10';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '10';
			case SIZE.STANDARD:
				return '16';
			case SIZE.LARGE:
				return '40';
			default:
				return '10';
		}
	};

	const handleClick = e => {
		/*
      We only want to stop propagation if onClick is set i props
      otherwise we want the click to propagate up
    */
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};
	return (
		<LockIconStyle onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg
				width={getWidth(size)}
				height={getHeight(size)}
				viewBox="0 0 40 40"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M11.7083 16V11.6667C11.7083 9.46758 12.5819 7.35856 14.1369 5.80357C15.6918 4.24858 17.8009 3.375 19.9999 3.375C22.199 3.375 24.3081 4.24858 25.863 5.80357C27.418 7.35856 28.2916 9.46758 28.2916 11.6667V16H28.3333C31.0947 16 33.3333 18.2386 33.3333 21V31.6667C33.3333 34.4281 31.0947 36.6667 28.3333 36.6667H11.6666C8.9052 36.6667 6.66663 34.4281 6.66663 31.6667V21C6.66663 18.2386 8.9052 16 11.6666 16H11.7083ZM15.5511 7.21779C16.731 6.03787 18.3313 5.375 19.9999 5.375C21.6686 5.375 23.2689 6.03787 24.4488 7.21779C25.6287 8.3977 26.2916 9.99801 26.2916 11.6667V16H13.7083V11.6667C13.7083 9.99801 14.3712 8.3977 15.5511 7.21779ZM11.6666 18H28.3333C29.9901 18 31.3333 19.3432 31.3333 21V31.6667C31.3333 33.3235 29.9901 34.6667 28.3333 34.6667H11.6666C10.0098 34.6667 8.66663 33.3235 8.66663 31.6667V21C8.66663 19.3432 10.0098 18 11.6666 18Z"
					fill={color}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M20 23.1667C20.5522 23.1667 21 23.6144 21 24.1667V27.5C21 28.0523 20.5522 28.5 20 28.5C19.4477 28.5 19 28.0523 19 27.5V24.1667C19 23.6144 19.4477 23.1667 20 23.1667Z"
					fill={color}
				/>
			</svg>
		</LockIconStyle>
	);
};

LockIcon.SIZE = SIZE;
LockIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string.isRequired,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD, SIZE.LARGE]),
};
